import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const ThankYouPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // דחיפת אירוע מותאם אישית ל-GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'thankYouPage', // שם האירוע
      page: {
        title: 'Thank You Page',
        url: window.location.href,
      },
    });

    // אופציונלי: חזרה לדף הבית אחרי 5 שניות
    // const timer = setTimeout(() => {
    //   navigate('/');
    // }, 5000);

    // return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center px-4">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
        <h1 className="text-3xl font-bold mb-4">תודה על פנייתך!</h1>
        <p className="text-lg text-gray-600 mb-8">
          הפרטים התקבלו בהצלחה. ניצור איתך קשר בהקדם האפשרי.
        </p>
        {/* <p className="text-sm text-gray-500">
          מועבר לדף הבית בעוד מספר שניות...
        </p> */}
      </div>
    </div>
  );
};

export default ThankYouPage;
